import dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import { AttributeFilter } from './attribute-filter';

export class DateAttributeFilter implements AttributeFilter {
  public attribute: string;
  public label: string;
  public operator: string;
  public tempValue?: Dayjs;
  public value?: Dayjs;
  public tempSecondValue?: Dayjs;
  public secondValue?: Dayjs;

  constructor(attribute: string, label: string, operator: string, value?: Dayjs, secondValue?: Dayjs) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  public updateValue(): any {
    const filters = Object.create({});
    if (!this.isChecked()) {
      return filters;
    }
    this.value = this.tempValue;
    if (this.operator !== 'between') {
      filters[this.attribute + '.' + this.operator] = this.value;
    } else {
      this.secondValue = this.tempSecondValue;
      filters[this.attribute + '.greaterThanOrEqual'] = this.value;
      filters[this.attribute + '.lessThanOrEqual'] = this.secondValue;
    }
    return filters;
  }

  public isChecked(): boolean {
    if (this.tempValue && this.operator !== 'between') {
      return true;
    }
    return this.operator === 'between' && !!this.tempSecondValue;
  }

  public htmlButtonText(): string {
    if (this.isChecked()) {
      let htmlContent = '<b>' + this.label + '</b> ';
      if (this.operator === 'between') {
        htmlContent += 'du <b>' + dayjs(this.value).format('DD/MM/YYYY') + '</b> au <b>' + dayjs(this.secondValue).format('DD/MM/YYYY') + '</b>';
      } else {
        if (this.operator === 'equals') {
          htmlContent += 'le';
        } else if (this.operator === 'greaterThanOrEqual') {
          htmlContent += 'à partir du';
        } else if (this.operator === 'lessThanOrEqual') {
          htmlContent += 'avant le';
        }
        htmlContent += ' ' + dayjs(this.value).format('DD/MM/YYYY');
      }
      return htmlContent;
    } else {
      return '';
    }
  }
}
